export default __webpack_public_path__ + "static/media/WorkArtRechard.85b76746.jpg";